import { Component, OnInit } from "@angular/core";
import { Router, NavigationStart, NavigationEnd } from "@angular/router";
import { TranslationService } from "app/services/translation.service";
import { FirestoreService } from "app/services/firestore.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-game-detail",
  templateUrl: "./game-detail.component.html",
  styleUrls: ["./game-detail.component.scss"],
})
export class GameDetailComponent implements OnInit {
  public game_data;
  public current_lang;
  public i18n;
  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private translation_service: TranslationService,
    private firestore_service: FirestoreService
  ) {}

  ngOnInit() {
    this.current_lang = this.translation_service.getLanguage();

    this.subscriptions.push(
      this.translation_service.current_dictionary_observable.subscribe(
        (dictionary) => {
          this.i18n = dictionary;
        }
      )
    );
    this.subscriptions.push(
      this.translation_service.current_lang_observable.subscribe((lang) => {
        this.current_lang = lang;
      })
    );
    this.i18n = this.translation_service.getDictionary();

    this.subscriptions.push(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) this.fetchGameData();
      })
    );

    this.fetchGameData();
  }

  ngOnDestroy() {
    for (let sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  fetchGameData() {
    let id: string;
    console.log(this.router.url);
    switch (this.router.url) {
      case "/games/halloween-im-hexenhaus":
        id = "GggTDep5cw9q0n9rYyXc";
        break;
      case "/games/au-schwarte":
        id = "QSJD7XPXKCY71rDoDJ1I";
        break;
      case "/games/bloxxs":
        id = "xz5bg7kdUtnsCt8cviGE";
        break;
      case "/games/cthulhu-clicker":
        id = "8Wzih8e7SrUeU6vfC7Jg";
        break;
      case "/games/hans-dampf-machine":
        id = "UaMytjcwIWhEJwan7tZl";
        break;
      case "/games/nachtschatten":
        id = "Ngv5qB9M3lS5ku55WGZr";
        break;
      default:
        this.router.navigate([""]);
    }

    this.firestore_service.getGameData(id).subscribe((data) => {
      this.game_data = data;
    });
  }
}
